import { betterFetch as defaultFetch } from '@e-socna/better-fetch';
import type { BetterFetch } from '@e-socna/better-fetch';

import { rechercheEntreprisesRetryStrategy } from './strategies/retry.strategy';
import type { RECHERCHE_ENTREPRISES_RATE_LIMITS } from './constants/rate-limits.constant';

/**
 * Create a configured fetcher for the "Recherche d'entreprises" API with automatic retry
 * handling
 *
 * @param serviceType - Type of service (only "search" for now)
 * @param fetch - Optional custom fetch implementation (defaults to betterFetch)
 * @returns A configured fetch function with retry strategy
 *
 * @example
 * ```typescript
 * import { createRechercheEntreprisesFetcher } from '@e-socna/organization-search';
 *
 * const rechercheEntreprisesFetch = createRechercheEntreprisesFetcher('search');
 * const data = await rechercheEntreprisesFetch<OrganizationSearchResponse>(url);
 * ```
 */
export const createRechercheEntreprisesFetcher =
  (
    serviceType: keyof typeof RECHERCHE_ENTREPRISES_RATE_LIMITS = 'search',
    fetch: BetterFetch = defaultFetch,
  ) =>
  <T>(url: string, options?: RequestInit) =>
    fetch<T>(url, options ?? {}, {
      retryStrategy: rechercheEntreprisesRetryStrategy(serviceType),
      retries: 5,
    });
